import { render, staticRenderFns } from "./EditarRepresentante.vue?vue&type=template&id=50d0e70a"
import script from "./EditarRepresentante.vue?vue&type=script&lang=js"
export * from "./EditarRepresentante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports